"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const hospitalEocByDrg = {
    name: 'hospital-episodes-of-care-by-drg',
    tableType: 'fact',
    grain: [
        'facility::key',
        'drg',
    ],
    claimsColumns: [
        'count_of_episodes',
    ],
    tableGrain: [
        '!facility',
        '!drg',
        'year_key',
    ],
    foreignKeys: [
        'facility::key',
        'drg:drg:drg'
    ],
};
const providerEocByDrg = {
    name: 'provider-episodes-of-care-by-drg',
    tableType: 'fact',
    grain: [
        'provider::key',
        'drg',
    ],
    claimsColumns: [
        'count_of_episodes',
    ],
    tableGrain: [
        '!provider',
        '!drg',
        'year_key',
    ],
    foreignKeys: [
        'provider::key',
        'drg:drg:drg',
    ]
};
exports.default = [
    hospitalEocByDrg,
    providerEocByDrg,
];
